import {
  getCoreRowModel,
  getFilteredRowModel,
  getSortedRowModel,
  useReactTable,
  type TableOptions,
} from '@tanstack/react-table';

type PhrTableOptions = Omit<
  TableOptions<object>,
  'getCoreRowModel' | 'getFilteredRowModel' | 'getSortedRowModel'
>;

export function usePhrReactTable(options: PhrTableOptions) {
  'use no memo';
  // eslint-disable-next-line react-hooks/incompatible-library
  return useReactTable({
    ...options,
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getSortedRowModel: getSortedRowModel(),
  });
}
